import * as Yup from "yup";

Yup.addMethod(Yup.object, "atLeastOneOf", function (...list) {
  return this.test({
    name: "atLeastOneOf",
    message: "${path} must have at least one of these keys: ${keys}",
    exclusive: true,
    params: { keys: list.join(", ") },
    test: (value) => value == null || list.some((f) => value[f] != null),
  });
});

export const username = () => Yup.string().email().lowercase();

export const password = () => Yup.string();

export const email = () =>
  Yup.string().trim().email("L'e-mail doit être valide").lowercase();

export const siret = () =>
  Yup.string()
    .trim()
    .test(
      "siret-valid",
      "Le SIRET ${path} doit contenir 14 chiffres",
      (value) =>
        !value || (value || "").replace(/\s+/gim, "").match(/^\d{14}$/),
    )
    .transform((value) => value.replace(/\D+/gim, ""));

export const phone = () =>
  Yup.string()
    .trim()
    .test(
      "phone-valid",
      "Le numéro de téléphone ${path} doit contenir des chiffres ou symboles valides",
      (value) => value.replace(/[\s()\-.]+/gim, "").match(/^\+?\d{2,15}$/),
    );

export const address = () =>
  Yup.object().shape({
    company: Yup.string().trim(),
    recipient: Yup.string().trim(),
    location: Yup.string().trim(),
    street: Yup.string().trim(),
    additional: Yup.string().trim(),
    postalCode: Yup.string().trim(),
    city: Yup.string().trim(),
    cedex: Yup.string().trim(),
    country: Yup.string().trim(),
  });

function normalizeSocialNumber(value) {
  if (!value) return "";
  return String(value).trim().toUpperCase().replace(/\s+/gim, "");
}

export const socialNumber = () =>
  Yup.string()
    .trim()
    .test(
      "is-social-number",
      "Le numéro n'est pas valide (15 chiffres)",
      (value) => {
        const normalizedValue = normalizeSocialNumber(value);

        return (
          !normalizedValue ||
          ((normalizedValue || "").replace(/[AB\d]/gim, "").length === 0 &&
            normalizedValue.length === 15)
        );
      },
    )
    .test(
      "is-plausible-social-number",
      "La valeur ne ressemble pas à un numéro de sécurité sociale valide",
      function (value) {
        if (!value) return true;

        const normalizedValue = normalizeSocialNumber(value);
        // x   = Sexe, 1 ou 2
        // xx  = Année de naissance
        // xx  = Mois de naissance, < 20
        // xx  = Département de naissance, dont 2A / 2B
        // xxx = Commune
        // xxx = Ordre
        // xx  = Clé de contrôle
        return /^[12]\d{2}[01]\d(2[AB]|\d{2})\d{3}\d{3}\d{2}$/.test(
          normalizedValue,
        );
      },
    )
    .test(
      "is-valid-social-number",
      "Le numéro n'est pas valide, veuillez vérifier votre saisie",
      function (value) {
        if (!value) return true;

        const normalizedValue = normalizeSocialNumber(value);
        if (!normalizedValue) return null;

        // Les 13 premiers caractères servent au calcul de la clé.
        const digitsWithoutKey = normalizedValue.slice(0, -2);
        // 2A et 2B sont remplacés par 19 et 18 selon la convention française.
        const digits = digitsWithoutKey
          .replace(/2A/gim, "19")
          .replace(/2B/gim, "18");

        if (!/^\d{13}$/.test(digits)) return null;

        // Clé de contrôle = 97 - (nombre % 97).
        const numericValue = Number(digits);
        const expectedKey = String(97 - (numericValue % 97)).padStart(2, "0");

        return normalizedValue.slice(-2) === expectedKey;
      },
    );

// // Tests de validation de la logique.
// [
//   "12345678901234", // pas 15 chiffres ou A/B
//   "1234567890123456", // pas 15 chiffres ou A/B
//   "12345678901234C", // pas 15 chiffres ou A/B
//   "323456789012345", // anormal
//   "18604B212345678", // anormal
//   "123456789012345", // anormal
//   "12345678901A345", // anormal
//   "186048512345678", // mauvaise clé
//   "186042A00145640", // mauvaise clé
//   "186048512345629", // bon
//   "186042A00145639", // bon
//   "286042A00145686", // bon
// ].forEach((value) => {
//   try {
//     socialNumber().validateSync(value);
//     console.log(value, ": valid");
//   } catch (err) {
//     console.log(value, ": invalid ->", err.message);
//   }
// });
